import React from 'react';
import { Stack } from '@mui/material';
import style from './GenericEquipmentTags.module.scss';
import { LineOfBusinessEnum } from '../../../constants/BusinessConstants';
import StatusBadge from '../../../components/StatusBadge/StatusBadge';

const GenericEquipmentTags = ({ item, settingForBranch }) => {
  const isMember = LineOfBusinessEnum.patientToMember.toString().toLowerCase() === 'member';
  const isCapHidden = Boolean(item?.hideCap);

  const chips = [
    { condition: item?.kit || item?.kit_item, label: 'Kit' },
    { condition: item?.approval || item?.centralized_approval_required, label: 'Approval' },
    { condition: settingForBranch?.pre_authorization_enabled && (item?.pre_auth || item?.need_pre_authorization), label: 'Pre-Auth' },
    { condition: item?.is_rx && settingForBranch?.o2_prescriptions_module_enabled, label: 'Rx' },
    { condition: !isCapHidden && (isMember && (!item?.cap && item?.oof)) || (isMember &&  (!item?.cap && item?.oof == undefined)) , label: 'OOF' },
    { condition: !isCapHidden && (isMember && item?.cap) || item?.formulary, label: 'Formulary' },
    { condition: !isCapHidden && (!isMember && !item?.cap) || item?.non_cap, label: 'Non-CAP' },
    { condition: !isCapHidden && (!isMember && item?.cap), label: 'Cap' },
    { condition: item?.hidden_equipment || item?.hidden, label: 'Hidden' },
  ];

  return (
    <Stack direction="row" spacing={1}>
      {chips.map(
        (chip) =>
          Boolean(chip.condition) && (
            <StatusBadge
              key={chip.label}
              status={chip.label}
            />
          )
      )}
    </Stack>
  );
};

export default GenericEquipmentTags;
